import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../services/firebaseConfig';

const adminAllowlist = [
  "yaw.srr@gmail.com",
  "admin2@example.com",
  "nankwasi999@gmail.com"
];

const ProtectedRoute = ({ children }) => {
  const user = auth.currentUser;
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!adminAllowlist.includes(user.email)) {
    return <div style={{textAlign:'center', marginTop:'4rem'}}>
      <h1>Unauthorized</h1>
      <p>You do not have permission to access this page.</p>
    </div>;
  }

  return children;
};

export default ProtectedRoute;
